export default {
  title: "Check <br /> your inbox",
  closeBtn: "Close"
};
